import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';
import { DocumentationReview } from '@core/model';

@Injectable({
  providedIn: 'root',
})
export class DocumentationReviewService {
  readonly apiUrl = inject(ShellService).getBaseUrlFor(ProductNames.CHAPP);
  private readonly httpClient = inject(HttpClient);

  getDocumentsReviewInformation(referralId: string): Observable<DocumentationReview | null> {
    return this.httpClient.get<DocumentationReview | null>(
      `${this.apiUrl}/referrals/${referralId}/documents-review`
    );
  }

  startDocumentsReview(referralId: string): Observable<void> {
    return this.httpClient.put<void>(
      `${this.apiUrl}/referrals/${referralId}/documents-review/start`,
      {}
    );
  }

  cancelDocumentsReview(referralId: string): Observable<void> {
    return this.httpClient.put<void>(
      `${this.apiUrl}/referrals/${referralId}/documents-review/cancel`, {});
  }

  finishDocumentsReview(referralNumber: string): Observable<void> {
    return this.httpClient.put<void>(
      `${this.apiUrl}/referrals/${referralNumber}/documents-review/complete`,{});
  }
}